<template>
  <ul class="member-avatar-list" :class="{ 'member-avatar-list--big': big }">
    <li v-for="member in limitedMembers" :key="member.user.id" class="member-avatar-list__item">
      <ATooltip placement="top" :delay="{ show: 10, hide: 0 }">
        <UserAvatar :image="member.user.image" :firstname="member.user.firstname" :lastname="member.user.lastname" />

        <template #popper>
          <div>
            <template v-if="member.user.id === user.id">
              {{ $t('team.member.card.isSelf') }}
            </template>

            <template v-else>
              {{ member.user.fullname || $t('deletedUser') }}
            </template>
          </div>
        </template>
      </ATooltip>
    </li>

    <li v-if="members.length > limit" class="member-avatar-list__item">
      <div class="member-avatar-list__more">
        {{ members.length - limit }}
      </div>
    </li>
  </ul>
</template>

<script>
import { take } from 'ramda';

export default {
  name: 'MemberAvatarList',

  props: {
    user: {
      type: Object,
      required: true,
    },

    members: {
      type: Array,
      required: true,
    },

    limit: {
      type: Number,
      default: 6,
    },

    big: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    limitedMembers() {
      return take(this.limit, this.members);
    },
  },
};
</script>

<style lang="scss">
@use 'settings/colors';
.member-avatar-list {
  display: flex;
  margin: 0;
  padding: 0 0 0 12px;
  list-style-type: none;
}

.member-avatar-list__item {
  margin-left: -12px;
  border-radius: 50%;
  background: #fff;
  padding: 2px;
  pointer-events: all;

  .user-avatar {
    cursor: help;
  }
}

.member-avatar-list__more {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: colors.$color-grey-100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(#000, 0.3);
  font-size: 14px;
}

.member-avatar-list--big {
  .member-avatar-list__item {
    margin-left: -16px;
  }

  .user-avatar {
    height: 40px;
    width: 40px;
  }
}
</style>
